import { render, staticRenderFns } from "./KeywordsField.vue?vue&type=template&id=31d42113&"
import script from "./KeywordsField.vue?vue&type=script&lang=js&"
export * from "./KeywordsField.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsField.vue?vue&type=style&index=0&id=31d42113&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports